import { IconBook } from '@/components/design/icons';
import type { FileDropAction } from './types';
import { useAuthStore } from '@/stores/auth';
import PlaybookDropFlow from './PlaybookDropFlow.vue';

/**
 * Run a playbook on the dropped file(s). Only offered when the user has the
 * playbooks permission. Its component lets the user pick an active playbook and
 * starts one run per dropped file.
 */
export const playbookAction: FileDropAction = {
  key: 'run-playbook',
  label: 'Run a playbook',
  icon: IconBook,
  component: PlaybookDropFlow,
  isAvailable: () => useAuthStore().userPermissions.can_use_playbooks,
};
